import { ChangeDetectorRef, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SdBannerComponent } from '@seb/web-design-system/core';

export class SliderUtils {
  constructor(
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef,
    private translateService: TranslateService,
    private subscriptions: Subscription
  ) {}

  setSliderA11y(context, slides, bullets?, thumbnails?) {
    if (slides?.length) {
      this.subscriptions.add(
        this.translateService
          .get('sliders.a11y.visual')
          .subscribe((text: string) => {
            let count = 1;
            slides.forEach((slide) => {
              if (slide.media) {
                slide.media.altText = text + ' ' + count + ' - ' + context;
                this.cdRef.detectChanges();
                count++;
              }
            });
          }),
      );
    }
    if (thumbnails) {
      this.subscriptions.add(
        this.translateService
          .get('sliders.a11y.thumbnail')
          .subscribe((text: string) => {
            let countThumb = 1;
            thumbnails.forEach((thumbnailSlide) => {
              if (thumbnailSlide.media) {
                thumbnailSlide.media.altText =
                  text + ' ' + countThumb + ' - ' + context;
                this.cdRef.detectChanges();
                countThumb++;
              }
            });
          }),
      );
    }
    if (bullets) {
      const totalBullets = bullets?.length;
      bullets.forEach((bullet, index) => {
        this.subscriptions.add(
          this.translateService
            .get('sliders.panel', {
              indexPanel: index + 1,
              totalPanel: totalBullets
            })
            .subscribe((text: string) => {
              this.renderer.setProperty(
                bullet,
                'innerHTML',
                '<button type="button" class="is-reset"><span class="is-visually-hidden">' +
                text +
                ' - ' +
                context +
                '</span></button>'
              );
            }),
        );
        this.cdRef.detectChanges();
      });
    }
  }

  updateSlides(sliderElement, mediaBanners, swiper) {
    this.setActiveSlide(sliderElement);
    this.setActiveBullet(sliderElement);

    if (mediaBanners) {
      mediaBanners
        .toArray()
        .forEach((media: SdBannerComponent, index: number) => {
          if (media.autoplayVideo() === true && index === swiper?.activeIndex) {
            media.playMedia();
          } else {
            media.pauseMedia();
          }
        });
    }
  }

  setActiveBullet(sliderElement) {
    const bullets = sliderElement?.nativeElement.querySelectorAll(
      '.swiper-pagination-bullet:not(.swiper-pagination-bullet-active) button',
    );
    const activeBullet = sliderElement?.nativeElement.querySelector(
      '.swiper-pagination-bullet-active button',
    );

    if (activeBullet) {
      this.renderer.setAttribute(activeBullet, 'aria-current', 'true');
    }
    if (bullets?.length) {
      bullets.forEach((bullet) => {
        this.renderer.removeAttribute(bullet, 'aria-current');
      });
    }
  }

  setActiveSlide(sliderElement) {
    const hiddenSlides = sliderElement?.nativeElement.querySelectorAll(
      '.c__item:not(.swiper-slide-visible)',
    );
    const visibleSlides = sliderElement?.nativeElement.querySelectorAll(
      '.c__item.swiper-slide-visible:not(.swiper-slide-active)',
    );
    const activeSlide = sliderElement?.nativeElement.querySelector(
      '.swiper-slide-active',
    );
    const focusableElementList =
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]),' +
      ' input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])';

    if (hiddenSlides) {
      hiddenSlides.forEach((el) => {
        const focus = el.querySelectorAll(focusableElementList);
        this.renderer.setAttribute(el, 'aria-hidden', 'true');
        this.renderer.setAttribute(el, 'tabindex', '-1');
        this.renderer.setAttribute(el, 'focusable', 'false');
        focus.forEach((focusEl) =>
          this.renderer.setAttribute(focusEl, 'tabindex', '-1'),
        );
      });
    }

    if (visibleSlides) {
      visibleSlides.forEach((el) => {
        const focus = el.querySelectorAll(focusableElementList);
        this.renderer.setAttribute(el, 'aria-hidden', 'false');
        this.renderer.setAttribute(el, 'tabindex', '0');
        this.renderer.setAttribute(el, 'focusable', 'true');
        focus.forEach((focusEl) =>
          this.renderer.setAttribute(focusEl, 'tabindex', '0'),
        );
      });
    }

    if (activeSlide) {
      const focus = activeSlide.querySelectorAll(focusableElementList);
      this.renderer.setAttribute(activeSlide, 'tabindex', '0');
      this.renderer.setAttribute(activeSlide, 'aria-hidden', 'false');
      this.renderer.setAttribute(activeSlide, 'focusable', 'true');
      focus.forEach((focusEl) =>
        this.renderer.setAttribute(focusEl, 'tabindex', '0'),
      );
      // Causes a scroll to the last slider of the page
      // activeSlide.focus();
    }
  }
}
